export default __webpack_public_path__ + "images/13027dd11a40f768e415331a61554ae2.png";